import api from './api';

// Get submit endpoint from environment variable or use default
const SUBMIT_DONOR_ENDPOINT = import.meta.env.VITE_SUBMIT_DONOR_ENDPOINT || '/ovatures/ovatures/saveOvaturesDonor';

/**
 * Save ovatures donor application
 * @param {Object} donorData - Donor application data
 * @returns {Promise} API response
 */
export const saveOvaturesDonor = async (donorData) => {
  const request = {
    ovaturesDonor: donorData
  };

  return api.post(SUBMIT_DONOR_ENDPOINT, request);
};
